var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "relative",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.nextStep.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-6" },
        [
          _c("form-input", {
            attrs: {
              label: "First Name",
              name: "first_name",
              id: "first_name",
              error: _vm.getErrorFor("first_name"),
              required: true,
            },
            model: {
              value: _vm.form.first_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "first_name", $$v)
              },
              expression: "form.first_name",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Last Name",
              name: "last_name",
              id: "last_name",
              error: _vm.getErrorFor("last_name"),
              required: true,
            },
            model: {
              value: _vm.form.last_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "last_name", $$v)
              },
              expression: "form.last_name",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            staticClass: "sm:col-span-2",
            attrs: {
              type: "number",
              label: "Phone",
              name: "phone",
              id: "phone",
              error: _vm.getErrorFor("phone"),
              required: true,
            },
            model: {
              value: _vm.form.phone,
              callback: function ($$v) {
                _vm.$set(_vm.form, "phone", $$v)
              },
              expression: "form.phone",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Address 1",
              name: "address_1",
              id: "address_1",
              error: _vm.getErrorFor("address_1"),
              required: true,
            },
            model: {
              value: _vm.form.address_1,
              callback: function ($$v) {
                _vm.$set(_vm.form, "address_1", $$v)
              },
              expression: "form.address_1",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Address 2",
              name: "address_2",
              id: "address_2",
              error: _vm.getErrorFor("address_2"),
            },
            model: {
              value: _vm.form.address_2,
              callback: function ($$v) {
                _vm.$set(_vm.form, "address_2", $$v)
              },
              expression: "form.address_2",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Town / City",
              name: "town",
              id: "town",
              error: _vm.getErrorFor("town"),
              required: true,
            },
            model: {
              value: _vm.form.town,
              callback: function ($$v) {
                _vm.$set(_vm.form, "town", $$v)
              },
              expression: "form.town",
            },
          }),
          _vm._v(" "),
          _c("form-select", {
            attrs: {
              label: "County",
              name: "county",
              id: "county",
              error: _vm.getErrorFor("county"),
              required: true,
              options: _vm.counties,
              "track-by": "value",
            },
            model: {
              value: _vm.form.county,
              callback: function ($$v) {
                _vm.$set(_vm.form, "county", $$v)
              },
              expression: "form.county",
            },
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              label: "Post Code",
              name: "post_code",
              id: "post_code",
              error: _vm.getErrorFor("post_code"),
              required: true,
            },
            model: {
              value: _vm.form.post_code,
              callback: function ($$v) {
                _vm.$set(_vm.form, "post_code", $$v)
              },
              expression: "form.post_code",
            },
          }),
          _vm._v(" "),
          _c("form-select", {
            attrs: {
              label: "County",
              name: "country",
              id: "country",
              error: _vm.getErrorFor("country"),
              required: true,
              options: _vm.countries,
              "track-by": "value",
            },
            model: {
              value: _vm.form.country,
              callback: function ($$v) {
                _vm.$set(_vm.form, "country", $$v)
              },
              expression: "form.country",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasFulfillableItems
        ? _c(
            "div",
            { staticClass: "flex items-center mt-6" },
            [
              _c("form-toggle", {
                model: {
                  value: _vm.form.delivery_same_as_billing,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "delivery_same_as_billing", $$v)
                  },
                  expression: "form.delivery_same_as_billing",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ml-2 focus:outline-none",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.form.delivery_same_as_billing =
                        !_vm.form.delivery_same_as_billing
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            Use this address as my delivery address\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.form.delivery_same_as_billing
        ? _c("div", { staticClass: "mt-8" }, [
            _c("h1", { staticClass: "text-xl mb-6" }, [
              _vm._v("Delivery Details"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-1 sm:grid-cols-2 gap-6" },
              [
                _c("form-input", {
                  attrs: {
                    label: "First Name",
                    name: "delivery_first_name",
                    id: "delivery_first_name",
                    error: _vm.getErrorFor("delivery_first_name"),
                  },
                  model: {
                    value: _vm.form.delivery_first_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_first_name", $$v)
                    },
                    expression: "form.delivery_first_name",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  attrs: {
                    label: "Last Name",
                    name: "delivery_last_name",
                    id: "delivery_last_name",
                    error: _vm.getErrorFor("delivery_last_name"),
                  },
                  model: {
                    value: _vm.form.delivery_last_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_last_name", $$v)
                    },
                    expression: "form.delivery_last_name",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  staticClass: "sm:col-span-2",
                  attrs: {
                    type: "number",
                    label: "Phone",
                    name: "delivery_phone",
                    id: "delivery_phone",
                    error: _vm.getErrorFor("delivery_phone"),
                  },
                  model: {
                    value: _vm.form.delivery_phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_phone", $$v)
                    },
                    expression: "form.delivery_phone",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  attrs: {
                    label: "Address 1",
                    name: "delivery_address_1",
                    id: "delivery_address_1",
                    error: _vm.getErrorFor("delivery_address_1"),
                  },
                  model: {
                    value: _vm.form.delivery_address_1,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_address_1", $$v)
                    },
                    expression: "form.delivery_address_1",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  attrs: {
                    label: "Address 2",
                    name: "delivery_address_2",
                    id: "delivery_address_2",
                    error: _vm.getErrorFor("delivery_address_2"),
                  },
                  model: {
                    value: _vm.form.delivery_address_2,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_address_2", $$v)
                    },
                    expression: "form.delivery_address_2",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  attrs: {
                    label: "Town / City",
                    name: "delivery_town",
                    id: "delivery_town",
                    error: _vm.getErrorFor("delivery_town"),
                  },
                  model: {
                    value: _vm.form.delivery_town,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_town", $$v)
                    },
                    expression: "form.delivery_town",
                  },
                }),
                _vm._v(" "),
                _c("form-select", {
                  attrs: {
                    label: "County",
                    name: "delivery_county",
                    id: "delivery_county",
                    error: _vm.getErrorFor("delivery_county"),
                    options: _vm.counties,
                    "track-by": "value",
                  },
                  model: {
                    value: _vm.form.delivery_county,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_county", $$v)
                    },
                    expression: "form.delivery_county",
                  },
                }),
                _vm._v(" "),
                _c("form-input", {
                  attrs: {
                    label: "Post Code",
                    name: "delivery_post_code",
                    id: "delivery_post_code",
                    error: _vm.getErrorFor("delivery_post_code"),
                  },
                  model: {
                    value: _vm.form.delivery_post_code,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_post_code", $$v)
                    },
                    expression: "form.delivery_post_code",
                  },
                }),
                _vm._v(" "),
                _c("form-select", {
                  attrs: {
                    label: "County",
                    name: "delivery_country",
                    id: "delivery_country",
                    error: _vm.getErrorFor("delivery_country"),
                    options: _vm.countries,
                    "track-by": "value",
                  },
                  model: {
                    value: _vm.form.delivery_country,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "delivery_country", $$v)
                    },
                    expression: "form.delivery_country",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-end mt-6" },
        [
          _c(
            "form-button",
            { staticClass: "w-full sm:w-auto", attrs: { type: "submit" } },
            [_vm._v("\n            Continue\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass:
            "absolute z-10 inset-0 bg-translucent-white-75 flex items-center justify-center",
        },
        [_c("preloader")],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }